var _defs, _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect10, _rect11, _rect12, _rect13, _rect14, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect15, _rect16, _rect17, _rect18, _rect19, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessConferenceMonochromatic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 691.8 566.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 273.14,
    y1: 307.94,
    x2: 243.87,
    y2: 703.02,
    gradientTransform: "translate(16.54 -24.03) rotate(0.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 631.54,
    y1: 350.48,
    x2: 611.7,
    y2: 618.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 98.38,
    y1: 419.67,
    x2: 315.27,
    y2: 410.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 263.82,
    y1: 580.96,
    x2: 242,
    y2: -137.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 263.18,
    y1: 251.17,
    x2: 244.34,
    y2: 1010.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 82.66,
    y1: 338.33,
    x2: 56.7,
    y2: 403.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4. ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.92,434.72c3.77,23.2,26.8,131.1,110.92,154,63.67,17.37,242.38-42.19,344.27-12.23,204.95,60.24,242.49-101.51,231-145.2-8-30.45-17.83-61-18.09-92.8-.27-33.27,11.38-66,12.66-99.48,3.22-84.79-56.35-168-137.63-192.34-34.8-10.41-63.24-21-99.55-21.33-73.69-.63-248.57,0-334.71,125.3-15.39,22.4-37.75,39.15-54.92,60.21-23,28.22-38.17,62.25-47.38,97.47C25.79,349.41,23.13,392.93,29.92,434.72Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 531.86,
    y: 290.26,
    width: 5.74,
    height: 147.17,
    fill: "#68e1fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 531.86,
    y: 290.26,
    width: 5.74,
    height: 147.17,
    fill: "#bcdbf2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.31,452.36l114.2,4.41c5.37.21,11,.45,15.47,1.53,7.19,1.74,9.17,5.29,6.52,8.1s-9,5-15.7,6.79c-41.58,11.16-99.88,10.9-153.39,10.14L81,479.78c-9.74-.14-19.81-.3-28.65-1.8s-16.13-4.71-14.89-8c1.12-3,8.54-5.14,16-6.65,21.9-4.43,47.89-5.84,73.25-7.1q57.67-2.88,115.58-5.26",
    transform: "translate(-26.2 -25.31)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M656.67,455.7l40.79,3.15a11.4,11.4,0,0,1,5.54,1.4c2.57,1.72,3.29,5.37,2.36,8.32s-3.18,5.29-5.58,7.25c-14.8,12.09-35.62,12.55-54.73,12.43l-90.16-.55c-3.48,0-7.08-.06-10.24-1.51s-5.78-4.69-5.35-8.14c.39-3.11,3-5.43,5.69-7.1,7.8-4.86,17.08-6.65,26.13-8.28q20.58-3.71,41.25-6.9",
    transform: "translate(-26.2 -25.31)",
    fill: "url(#linear-gradient-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 435.16,
    y: 131.83,
    width: 193.38,
    height: 177.9,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 534.72,
    y: 155.69,
    width: 82.08,
    height: 138.97,
    fill: "#68e1fd",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 541.19,
    y: 169.03,
    width: 71.84,
    height: 66.58,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 429.54,
    y: 127.58,
    width: 202.44,
    height: 7.61,
    fill: "#68e1fd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 429.54,
    y: 307.1,
    width: 202.44,
    height: 7.61,
    fill: "#68e1fd"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 236.15,
    y: 410.34,
    width: 4.42,
    height: 40.88,
    transform: "translate(450.52 836.24) rotate(-180)",
    fill: "#4c506d"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 216.84,
    y: 450.37,
    width: 49.09,
    height: 5.73,
    transform: "translate(456.58 881.17) rotate(-180)",
    fill: "#4c506d"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 216.84,
    y: 450.37,
    width: 49.09,
    height: 5.73,
    transform: "translate(456.58 881.17) rotate(-180)",
    fill: "#2f3554"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 214.97,
    y: 395.41,
    width: 42.36,
    height: 14.92,
    rx: 7.46,
    transform: "translate(446.1 780.44) rotate(180)",
    fill: "#4c506d"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 223.81,
    y: 395.41,
    width: 42.36,
    height: 14.92,
    rx: 7.46,
    transform: "translate(463.79 780.44) rotate(-180)",
    fill: "#2f3554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.94,340.27v14.21a9.5,9.5,0,0,0,9.5,9.5h14.2a9.51,9.51,0,0,0,9.51-9.5V340.27a9.51,9.51,0,0,0-9.51-9.51h-14.2a8.83,8.83,0,0,0-1.27.09A9.5,9.5,0,0,0,202.94,340.27Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#4c506d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.88,354.56a9.45,9.45,0,0,0,1.6,4.18c2.57,3.52,7.57,3.95,11.92,4.06,3.24.08,14.54,2.51,13.73-2.92-.43-2.85-2.14-5.88-3-8.63s-2.68-6.3-2.68-9.08a51.47,51.47,0,0,0-2.42-7.74,16.85,16.85,0,0,0-2.2-3.67H212.43a3.61,3.61,0,0,0-1.18.14c.46,3.82-2.07,6.52-3.46,9.86-1.25,3-1.23,6.29-1.19,9.5A31,31,0,0,0,206.88,354.56Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.49,355.14a27.1,27.1,0,0,1,1.77,5.08c.38,2.14,1,4.23,1.41,6.38a72.72,72.72,0,0,1,1.07,13.09c0,1.73,0,3.69,1.24,4.89a6.14,6.14,0,0,0,3.17,1.3c2.25.45,4.28,1.34,6.52,1.72a44.4,44.4,0,0,0,7.38.44c7.28,0,20.83-.81,20.38-11-.49-11.54-1.39-22.76-3-34.26-.55-3.85-.66-8.29-1.83-12-1-3.11-4.61-3.14-7.62-2.82l-.57.06c-.58.06-1.16.13-1.73.21a82.48,82.48,0,0,1-12.07.35c-4.54-.14-11.79-.59-16.25,3.68a9.78,9.78,0,0,0-.87.94C221,338.62,223.42,347.4,226.49,355.14Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.2,352.42a47.3,47.3,0,0,1,.6,7.34,4.46,4.46,0,0,1-.53,2.48c-.76,1.16-2.35,1.39-3.74,1.36a16.81,16.81,0,0,1-11.68-4.89,72.52,72.52,0,0,1-7.92-9.32,7.65,7.65,0,0,1-1.79-5.65c0-2.79.11-5.59.36-8.37.06-.65,4.55-.14,5,0a18.32,18.32,0,0,1,4.75,2.13c.17-1.83-.35-3.92-.5-5.78a2.81,2.81,0,0,1,.19-1.63c.51-.91,1.78-1,2.83-.9,2.25.16,4.74.54,6.14,2.3a8.69,8.69,0,0,1,1.3,2.75C282.23,340.17,284.24,346.23,285.2,352.42Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.54,354.76a4,4,0,0,1-.27,2.72c-1,1.52-3.3,1-4.93.26a38.34,38.34,0,0,1-6.21-3.74,1.68,1.68,0,0,0-1.23-.48,1.62,1.62,0,0,0-.82.6,32.24,32.24,0,0,1-10.9,7.84c-1.41.62-3.27,1-4.29-.11s-.21-3.19.69-4.58l10.72-16.56a1.21,1.21,0,0,1,.57-.55c.41-.14.82.17,1.15.45a22.28,22.28,0,0,0,4.87,3.2,2.84,2.84,0,0,0,2.07.37c1-.34,1.34-1.56,1.47-2.6a27.59,27.59,0,0,0,.14-5.22,4.86,4.86,0,0,1,.14-2.15,2.4,2.4,0,0,1,3.43-1c1.32,1,1.11,4.78,1.33,6.39Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d8dae1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M241.48,354.18a15.52,15.52,0,0,0,3.85,4.61c1.75,1.36,5.8,6.71,8.31,5.08a10.16,10.16,0,0,1-3.81,2.1c3.88,2.73,8.77,3.46,13.43,4.33a9.11,9.11,0,0,1,3.44,1.16,3.24,3.24,0,0,1,1.58,3.07c-.34,2.1-3,2.73-5.14,2.86-5.23.32-10.49.43-15.69,1.07-4.43.54-9.2,1.7-11.93,5.23a2,2,0,0,1-.79.72,1.22,1.22,0,0,1-1.4-.68,3.78,3.78,0,0,1-.29-1.67,48,48,0,0,0-2-12.82c-.5-1.68-.56-3.39-1.05-5-.6-2-1.69-3.87-2.37-5.84a57.17,57.17,0,0,1-2.73-12.27c-.32-2.93-.11-6.47,2.41-8a5.53,5.53,0,0,1,6,.62,12.61,12.61,0,0,1,3.68,5.11C238.49,347.23,239.63,351,241.48,354.18Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d8dae1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.28,335.91a1.82,1.82,0,0,0-.33.63,1.46,1.46,0,0,0,.15.73,136.15,136.15,0,0,1,5.52,19.05c1.34,5.67,2.69,11.38,3,17.21a3.55,3.55,0,0,1-.09,1.26c-.44,1.44-2.32,1.89-3.14,3.15l-2.73-3.11a2.19,2.19,0,0,1-.42-.62,2.25,2.25,0,0,1,0-1c.93-6.23-.09-12.58-1.55-18.7-1.25-5.26-2.84-10.53-2.74-15.94a2.31,2.31,0,0,0-.49-1.83,3.76,3.76,0,0,0-.9-.44,3,3,0,0,1-1.38-4.13,3.62,3.62,0,0,0,1.66-.42,2.43,2.43,0,0,1,1.68-.22C251.75,332,253,334.72,252.28,335.91Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M226.34,332.29c4.46-4.27,11.71-3.82,16.25-3.68a82.48,82.48,0,0,0,12.07-.35c.57-.08,1.15-.15,1.73-.21-2.39-1-5.79-.32-8.35-.24q-5.81.19-11.61.71C232.76,328.85,228.72,329.48,226.34,332.29Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M240.08,316.32a8.17,8.17,0,0,0,9.93,4.91s-1.88,5.74.48,9.21c0,0-1.57,4-12.12-1.91,0,0,2.85-.24,2.07-6.09a12.66,12.66,0,0,0-2.07-5.63A1,1,0,0,0,240.08,316.32Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d68369"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M245.26,323.7c5.57,1.64,10.11-2.95,12.17-9.73.22-.74.41-1.51.57-2.3a29.51,29.51,0,0,0,.61-6.86c-.3-11.12-16.29-10-16.29-10C229.38,297.71,235.57,320.86,245.26,323.7Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M279.88,392.89l-.33-.34c1.31,1.47,2.19,2.53,2.46,2.86C281.35,394.54,280.63,393.7,279.88,392.89Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#dc9bd5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.46,293a8.51,8.51,0,0,1,5,3.48c.61.91,1,1.94,1.74,2.79,1,1.21,2.48,2.08,3,3.56a11.21,11.21,0,0,1-7.33-1.33,2.05,2.05,0,0,1-1.75,1,6.13,6.13,0,0,1-2.07-.39,1.9,1.9,0,0,0-1.15-.1,2.28,2.28,0,0,0-.76.55,5.12,5.12,0,0,1-4.82,1c-1-.3-2-.91-2.93-.6s-1.54,1.67-1.54,2.82a11.56,11.56,0,0,1-.09,3.43c-.7.12-.84-1-1.46-1.42s-1.21.11-1.53.64a2.52,2.52,0,0,0,.29,2.92,1.66,1.66,0,0,1,.48.67,1.24,1.24,0,0,1-.13.77l-1.08,2.73A64.79,64.79,0,0,0,232,305.7c-.86-1.25-1.86-2.68-1.47-4.15s2-2.55,1.64-4a8.28,8.28,0,0,1-.24-.81,2.12,2.12,0,0,1,.25-1.18,11,11,0,0,1,7.57-5.77,24.23,24.23,0,0,1,9.78.09c3.24.56,6.44,1.37,9.72,1.62.27,0,.58.07.7.31a.63.63,0,0,1,0,.36c-.13.7-.79,1.17-1.32,1.66s-1,1.28-.61,1.89",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241.39,380s6.77,16.92,12.21,18.7,25.56,7.91,25.56,7.91l28,52.71,11-6.77-24.7-61.66-21.92-11.23S265.93,379.82,241.39,380Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232,383.25s-1.27,15.43,4.17,17.21,25.55,7.92,25.55,7.92l29.92,57.18,12.43-5-28-67.89-21.91-11.23S241.43,376.8,232,383.25Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#4c506d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M322.66,454.51a29.14,29.14,0,0,1,4.28.43,7.09,7.09,0,0,1,3.63,1.47,3.45,3.45,0,0,1,1.13,2,2.6,2.6,0,0,1-.67,2.17,4.41,4.41,0,0,1-1.76.94c-1.51.54-3,1.06-4.54,1.59a37,37,0,0,1-10,2.43,1.36,1.36,0,0,1-.6-.06,1.68,1.68,0,0,1-.4-.3c-2.06-2-4-4.38-4.5-7.22a.57.57,0,0,1,0-.29.55.55,0,0,1,.24-.26,24.1,24.1,0,0,1,6.75-3.17C318.42,453.62,320.43,454.46,322.66,454.51Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.24,461a29.28,29.28,0,0,1,4.28.43,7.16,7.16,0,0,1,3.63,1.47,3.39,3.39,0,0,1,1.12,2,2.58,2.58,0,0,1-.67,2.17,4.35,4.35,0,0,1-1.76.94c-1.51.54-3,1.06-4.54,1.58a36.46,36.46,0,0,1-10,2.44,1.39,1.39,0,0,1-.61-.06,1.62,1.62,0,0,1-.39-.3c-2.06-2-4-4.38-4.5-7.22a.61.61,0,0,1,0-.3.64.64,0,0,1,.24-.25,24.23,24.23,0,0,1,6.75-3.17C302,460.14,304,461,306.24,461Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.7,340.3s9.55,21.4,19.67,24.29,22.31-27.1,22.31-27.1l-8.12-3.06-13.63,13.7s-8.45-17.94-11.88-17.12S222.41,336.62,223.7,340.3Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M267.75,322.5a4.31,4.31,0,0,0,1,2.26A14,14,0,0,1,270,329a8.94,8.94,0,0,0,1.72,4.06,3.49,3.49,0,0,0,4,1.06,3.38,3.38,0,0,0,1.64-2.53,7.4,7.4,0,0,0-.35-3.09,19.68,19.68,0,0,0-1.48-3.77,9.38,9.38,0,0,0-2.29-3C271.85,320.54,267.94,319.52,267.75,322.5Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d68369"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.69,323.79a5.61,5.61,0,0,1,2.15-2.17,6,6,0,0,1,2.71-.38c1.8,0,3.9.33,4.76,1.9a4.06,4.06,0,0,1-.39,3.89c-.69,1.17-1.67,2.15-2.38,3.32-1,1.66-1.48,3.74-3,4.95a5.34,5.34,0,0,1-2.19,1c-2.64.61-6.09-.65-5.47-3.8A27.45,27.45,0,0,1,263.69,323.79Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 127.7,
    y: 409.77,
    width: 4.42,
    height: 40.88,
    transform: "translate(233.62 835.11) rotate(-180)",
    fill: "#4c506d"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 108.39,
    y: 449.81,
    width: 49.09,
    height: 5.73,
    transform: "translate(239.67 880.04) rotate(-180)",
    fill: "#4c506d"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 108.39,
    y: 449.81,
    width: 49.09,
    height: 5.73,
    transform: "translate(239.67 880.04) rotate(-180)",
    fill: "#2f3554"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 106.52,
    y: 394.85,
    width: 42.36,
    height: 14.92,
    rx: 7.46,
    transform: "translate(229.2 779.31) rotate(-180)",
    fill: "#4c506d"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 115.36,
    y: 394.85,
    width: 42.36,
    height: 14.92,
    rx: 7.46,
    transform: "translate(246.89 779.31) rotate(180)",
    fill: "#2f3554"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.48,339.7v14.21a9.51,9.51,0,0,0,9.5,9.51h14.21a9.51,9.51,0,0,0,9.51-9.51V339.7a9.5,9.5,0,0,0-9.51-9.5H104a9,9,0,0,0-1.27.08A9.52,9.52,0,0,0,94.48,339.7Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#4c506d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.43,354a9.45,9.45,0,0,0,1.6,4.18c2.57,3.52,7.56,3.95,11.92,4.06,3.24.09,14.53,2.51,13.72-2.92-.42-2.85-2.13-5.87-3-8.62s-2.68-6.3-2.68-9.08a52,52,0,0,0-2.42-7.75,16.79,16.79,0,0,0-2.2-3.66H104a3.57,3.57,0,0,0-1.18.13c.46,3.83-2.07,6.52-3.47,9.86-1.24,3-1.22,6.29-1.18,9.51A29.44,29.44,0,0,0,98.43,354Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.93,314.73c2.17,3,8.76,5.83,8.76,5.83.76-2.93-.85-4-.85-4-1.7.15-3.91-4-3.19-5.27.9-1.61,2.14-1,3-.34a7.88,7.88,0,0,0,3-5.54c.11-1.27-2.08-4.86,2.12-6.41s10.12,0,10.12,0,1.53-3.92-3.36-5.79c-11-4.23-24.18,3-23.44,15.36.19,3.35.42,7.16-1.91,9.58a12.6,12.6,0,0,1-4.76,2.62,14.56,14.56,0,0,0-6,3.7c-1.55,1.8-2.21,4.55-1,6.58.59,1,1.6,1.91,1.34,3a3.14,3.14,0,0,1-.84,1.3,18,18,0,0,0-4.67,9.85,12.92,12.92,0,0,0,3.2,10.24c3.4,3.56,8.83,4.49,13.7,3.76A17.6,17.6,0,0,0,128.64,354c4.06-4.5,4.58-11,5.72-17a3.58,3.58,0,0,1,.84-2c1.19-1.11,3.09-.21,4.72-.25,2.8-.06,4.68-3.13,4.75-5.93s-1.07-5.47-1.63-8.21-.4-6,1.72-7.81c.8-.69,1.8-1.1,2.65-1.72,3.79-2.73,3.56-9,.33-12.35s-8.42-4.19-13-3.39c-3.69.64-12,2.69-13.74,6.1S120.75,311.75,122.93,314.73Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ff681c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M111.65,336.24a11.82,11.82,0,0,1,2.51-8.4c2.21-2.57,5.58-3.72,8.72-5,1.33-.53,2.77-1.21,3.34-2.53a11.78,11.78,0,0,0,.44-2.8c.15-.94.7-2,1.64-2.09a2.22,2.22,0,0,1,1.61.57c2,1.53,2.63,4.35,2.18,6.83a18.4,18.4,0,0,1-3.23,6.75,27.7,27.7,0,0,0-3.71,6.54c-.61,1.81-.78,3.74-1.22,5.6-1,4.09-4.41,6.52-8.44,4.2C112.69,344.32,111.82,339.1,111.65,336.24Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ff681c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M148.52,327.5a136.16,136.16,0,0,1-14.38.54c-4.85-.14-12.79-.65-17.12,4.62-5.38,6.54-.75,18,3,26.66,1.4,3.22,2.08,13.64,1.36,21.26,0,0,15.08,5.27,28.34,2.53L154.27,366S166.92,347.25,148.52,327.5Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#4c506d"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.49,293.2s6.4.37,8.3,9.64-7.34,9.11-7.34,9.11l-5.61-16.08Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ff681c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M138.23,323.75c5.79.48,9.31-4.92,10-12a22.83,22.83,0,0,0,.09-2.36,29.08,29.08,0,0,0-.78-6.84c-2.54-10.84-18-6.5-18-6.5C117.44,301.49,128.17,322.92,138.23,323.75Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.63,315.75c1,3.2,5.21,8.85,10,7.53a6.19,6.19,0,0,0,.38,6.59s-1.56,4-12.11-1.9c0,0,2.85-.24,2.07-6.1a12.59,12.59,0,0,0-2.07-5.62A1,1,0,0,0,131.63,315.75Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d68369"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M142.37,295.82c-1.51,5.24-3.52,12.68-8.64,15.55a4.3,4.3,0,0,1-2.36.74c-.78-.16-.71-.78-1.31-1.33a1.36,1.36,0,0,0-1.55-.27,1.6,1.6,0,0,0-.63,1.39,3.74,3.74,0,0,0,1.79,3.2,9.35,9.35,0,0,1,1.45.82,2.94,2.94,0,0,1,.86,1.89,5.06,5.06,0,0,1-2.51,4.83.6.6,0,0,1-.34.11.67.67,0,0,1-.38-.22l-2.29-2.09a19.16,19.16,0,0,1-2.92-3.12,9.41,9.41,0,0,1-1.63-5.26c0-.85.33-1.7.32-2.52a12,12,0,0,0-.85-3.13,11,11,0,0,1-.77-4.05c.18-2.72,2.44-4.87,4.88-6.08,3.86-1.91,8.31-2.12,12.61-2.17a6.41,6.41,0,0,1,2.54.34C141.38,294.76,141.68,295.57,142.37,295.82Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ff681c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.12,361.76l-4.42,9.72s-9.54-11.86-13.13-24.66c-3.16-11.31,2.45-14.16,2.45-14.16,4.28-1.57,7.2,4.54,11.42,16.9C130.76,356.36,132.12,361.76,132.12,361.76Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M127.7,371.48s-.17-7.9,3.68-9.47,30.83-5.8,30.83-5.8l2.53,2.92S138.25,374.4,127.7,371.48Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M171.42,392.33c-.1-.12-.21-.23-.32-.34,1.31,1.47,2.19,2.53,2.46,2.86C172.89,394,172.18,393.14,171.42,392.33Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#dc9bd5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.75,393.88c.79,4.61,3.93,8.56,7.75,11.24s8.29,4.26,12.76,5.61c2.65.81,4.29,4.2,6.68,5.61a5.9,5.9,0,0,1,2.19,1.83c.87,1.41.43,3.22,0,4.81q-3,10.54-6.09,21.09c-1,3.49-2,7.19-1.06,10.7s4.65,6.53,8.09,5.37q10.11-16.31,20.2-32.61s3.32-13.12-3.65-24.28c-3-4.81-26.57-24.65-26.57-24.65-6-.87-12.15-1.28-18-1.62C121.39,382.67,118.79,388.25,119.75,393.88Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140,378.6s24,19.57,26.57,24.65c7,14.17,3.65,24.28,3.65,24.28l17.67,28.39c4.09.09,9.57-1,9.77-5.1a7.94,7.94,0,0,0-.8-3.32q-6.65-16.58-13.3-33.14c-2.63-6.57-5.35-13.28-9.56-18.92l-.38-.49,0,0-.05-.06c-.27-.33-1.15-1.39-2.46-2.86a.08.08,0,0,0,0,0c-3.82-4.28-11.28-11.92-18.18-15,0,0-8,2.22-12.83,1.62Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140,378.6s24,19.57,26.57,24.65c7,14.17,3.65,24.28,3.65,24.28l17.67,28.39c4.09.09,9.57-1,9.77-5.1a7.94,7.94,0,0,0-.8-3.32q-6.65-16.58-13.3-33.14c-2.63-6.57-5.35-13.28-9.56-18.92l-.38-.49,0,0-.05-.06c-.27-.33-1.15-1.39-2.46-2.86a.08.08,0,0,0,0,0c-3.82-4.28-11.28-11.92-18.18-15,0,0-8,2.22-12.83,1.62Z",
    transform: "translate(-26.2 -25.31)",
    fill: "url(#linear-gradient-3)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M152.34,466.34c1.58,1.46,3.68,2.91,3.6,5.06a1,1,0,0,1-.17.6,1.15,1.15,0,0,1-.82.33c-4.85.54-9.35-2.41-13.12-5.51a5.36,5.36,0,0,1-2.17-2.89,6,6,0,0,1,1-3.54,32.71,32.71,0,0,0,2.18-5.64c-.16.58,2.28,2.63,2.69,3,.86.76,2.15,1.31,2.83,2.24a28.16,28.16,0,0,1,1.33,2.95A13.69,13.69,0,0,0,152.34,466.34Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M202.41,457.27c1.7.6,3.68.93,4.76,2.38a1.66,1.66,0,0,1,.36.9c0,.89-1,1.38-1.91,1.56-3.5.71-7.12.21-10.65-.3a3,3,0,0,1-1.3-.4,2.94,2.94,0,0,1-.92-1.59l-1.4-4.29a.69.69,0,0,1,0-.4.6.6,0,0,1,.28-.31,18.16,18.16,0,0,1,3-1.72c1.44-.65,1.53-.62,2.5.51A12.52,12.52,0,0,0,202.41,457.27Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M165.11,355.64c2.78-.44,5.92-.8,8.18.89a10.5,10.5,0,0,1,2.58,3.31,2.1,2.1,0,0,1-1.52,3.67c-2.57.62-5.34,1.21-7.81.24-1.82-.71-3.29-2.22-5.19-2.67a2.58,2.58,0,0,1-.92-.32,1.58,1.58,0,0,1-.53-.84C158.76,356.13,162.58,356,165.11,355.64Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195,465.07a1.28,1.28,0,0,0,.43.49,1.46,1.46,0,0,0,.88,0,23.73,23.73,0,0,1,4.77-.17,63.9,63.9,0,0,0,9.66-.89c1.4-.2,2.95-.5,3.76-1.65a.89.89,0,0,0,.19-.45,1,1,0,0,0-.28-.67,11.86,11.86,0,0,0-5.33-3.64,6.85,6.85,0,0,0-2.44-.53,2.88,2.88,0,0,0-2.21,1c-.58.73-.66,1.78-1.31,2.44a3.5,3.5,0,0,1-2.67.71,21.26,21.26,0,0,1-3.28-.38c-.83-.16-2-.72-2.85-.5C192.44,461.31,194.44,464.11,195,465.07Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M138.47,466.42a1.33,1.33,0,0,0,.09.74,1.5,1.5,0,0,0,.82.56,27.23,27.23,0,0,1,4.64,2.89,72.51,72.51,0,0,0,9.72,5.3c1.46.7,3.12,1.41,4.62.83a1,1,0,0,0,.47-.31,1.18,1.18,0,0,0,.16-.81,13.64,13.64,0,0,0-2.74-6.85,7.85,7.85,0,0,0-2-2,3.29,3.29,0,0,0-2.73-.47c-1,.32-1.76,1.27-2.8,1.48a4,4,0,0,1-3-1,25.79,25.79,0,0,1-2.88-2.44c-.67-.68-1.45-2-2.38-2.3C138.43,461.22,138.54,465.16,138.47,466.42Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.86,336.53a31.3,31.3,0,0,0-1.37,6.37l-.42,2.93a3.2,3.2,0,0,0,.1,1.82c.48,1,2.43.61,3.39.76l5.17.82q5.16.79,10.35,1.52a20.34,20.34,0,0,0-.1-5.29c-.31-1.66-1-3.22-1.44-4.86-.33-1.33-.45-2.71-.79-4a12.68,12.68,0,0,0-4.72-7c-3.63-2.66-9,3.77-10.07,6.67A2,2,0,0,0,112.86,336.53Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#4c506d"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 341.22,
    y: 409.59,
    width: 4.42,
    height: 40.88,
    transform: "translate(660.66 834.75) rotate(-180)",
    fill: "#4c506d"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 321.91,
    y: 449.62,
    width: 49.09,
    height: 5.73,
    transform: "translate(666.72 879.67) rotate(-180)",
    fill: "#4c506d"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 321.91,
    y: 449.62,
    width: 49.09,
    height: 5.73,
    transform: "translate(666.72 879.67) rotate(-180)",
    fill: "#2f3554"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 320.04,
    y: 394.66,
    width: 42.36,
    height: 14.92,
    rx: 7.46,
    transform: "translate(656.24 778.95) rotate(180)",
    fill: "#4c506d"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 328.88,
    y: 394.66,
    width: 42.36,
    height: 14.92,
    rx: 7.46,
    transform: "translate(673.93 778.95) rotate(180)",
    fill: "#2f3554"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M308,339.52v14.21a9.5,9.5,0,0,0,9.5,9.51h14.2a9.4,9.4,0,0,0,4.6-1.19,9.61,9.61,0,0,0,3-2.58,9.38,9.38,0,0,0,1.93-5.74V339.52a9.5,9.5,0,0,0-9.51-9.5h-14.2a8.84,8.84,0,0,0-1.27.08A9.5,9.5,0,0,0,308,339.52Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#4c506d"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M312,353.81a9.45,9.45,0,0,0,1.6,4.18c2.57,3.52,7.57,3.95,11.92,4.06,3.24.08,14.54,2.51,13.73-2.92-.43-2.85-2.14-5.87-3-8.62s-2.68-6.31-2.68-9.09a51.84,51.84,0,0,0-2.42-7.74,16.55,16.55,0,0,0-2.2-3.66H317.51a3.63,3.63,0,0,0-1.19.13c.47,3.83-2.06,6.52-3.46,9.86-1.25,3-1.22,6.29-1.18,9.5A29.47,29.47,0,0,0,312,353.81Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M336.45,314.55c2.17,3,8.77,5.83,8.77,5.83.76-2.94-.86-4-.86-4-1.69.15-3.91-4-3.19-5.27.9-1.62,2.14-1,3-.34a7.87,7.87,0,0,0,3-5.54c.1-1.27-2.09-4.86,2.11-6.41s10.13,0,10.13,0,1.52-3.93-3.37-5.8c-4-1.52-9.92-.63-14.06-.15a13.79,13.79,0,0,0-6.34,1.92c-2.77,1.9-4,5.37-4.53,8.69s-.52,6.75-1.58,9.94c-.58,1.77-1.5,3.47-1.55,5.33s1.21,4,3.07,3.95c.72,0,1.51-.32,2.13.06s.74,1.4,1.3,2c1,1,2.69,0,4.1-.32,1.84-.38,3.89.64,5.55-.22.69-.36,1.26-1,2-1.1,1-.1,1.83.82,2.83.94,1.71.21,3-1.9,4.7-1.85a6.75,6.75,0,0,1,2.17.75,4.8,4.8,0,0,0,6.1-3.34,1.14,1.14,0,0,0,1.67-.32,3.24,3.24,0,0,0,.38-1.88c0-5.59,1.56-14.33-2.72-18.78-3.23-3.37-8.41-4.2-13-3.4-3.69.65-12,2.69-13.75,6.11S334.28,311.57,336.45,314.55Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#32384f"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37,364.59c-3.48-9-6.8-19.47-6.8-19.47L362,327.32c8.77-.6,11.49,10.49,13.39,16.49,1.59,5,5.82,17,7.17,20.78Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d68369"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M408.27,362.49c-2.27,2.78-6.37,3-10,3l-17.62-.06a3.52,3.52,0,0,1-2-.39,3.36,3.36,0,0,1-1.08-1.48c-.77-1.66-4.17-8.46-2.77-10s8.23,1.4,10,1.89Q396.61,358.75,408.27,362.49Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d68369"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M367.76,328.34a17.29,17.29,0,0,1,4,4.64l11.77,17.46a8.26,8.26,0,0,0,5.28,4.1l11.62,4.35c.41.15.86.35,1,.75s-.23,1-.59,1.39l-4.28,4.48a3.52,3.52,0,0,1-1.59,1.12,3.42,3.42,0,0,1-1.86-.24l-22.75-7.31a5.32,5.32,0,0,1-2-1c-1-.94-1.17-2.49-1.26-3.88a45.15,45.15,0,0,0-2-11.5c-1.33-3.93-3.57-7.66-4.08-11.83-.18-1.41-.51-3.3.91-4.07S366.54,327.47,367.76,328.34Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M362,327.32a136.16,136.16,0,0,1-14.38.54c-4.84-.14-12.79-.65-17.12,4.62-5.37,6.54-.74,18,3,26.66,1.4,3.21,2.09,13.64,1.36,21.26,0,0,15.08,5.27,28.34,2.52l4.55-17.07S380.44,347.06,362,327.32Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M356,293s6.4.38,8.3,9.64-7.34,9.12-7.34,9.12l-5.61-16.08Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#32384f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M351.75,323.57c5.79.48,9.31-4.93,10-12,.07-.77.1-1.56.1-2.36a29.1,29.1,0,0,0-.79-6.84c-2.53-10.84-18-6.5-18-6.5C331,301.31,341.69,322.74,351.75,323.57Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M345.16,315.57c1,3.2,5.21,8.85,10,7.53a6.17,6.17,0,0,0,.39,6.59s-1.57,4-12.12-1.91c0,0,2.85-.23,2.07-6.09a12.45,12.45,0,0,0-2.07-5.62A1,1,0,0,0,345.16,315.57Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#d68369"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M355.89,295.64c-1.5,5.24-3.52,12.68-8.63,15.55a4.36,4.36,0,0,1-2.37.74c-.78-.16-.7-.78-1.31-1.33a1.35,1.35,0,0,0-1.55-.27,1.61,1.61,0,0,0-.63,1.39,3.7,3.7,0,0,0,1.8,3.19,9.29,9.29,0,0,1,1.44.83,2.92,2.92,0,0,1,.86,1.89,5.06,5.06,0,0,1-2.5,4.83.63.63,0,0,1-.35.11.67.67,0,0,1-.38-.22L340,320.26a18.79,18.79,0,0,1-2.93-3.12,9.49,9.49,0,0,1-1.63-5.26c0-.85.33-1.71.32-2.52a12.41,12.41,0,0,0-.84-3.13,11.17,11.17,0,0,1-.78-4.05c.19-2.72,2.44-4.88,4.88-6.08,3.86-1.91,8.31-2.13,12.62-2.17a6.39,6.39,0,0,1,2.53.34C354.9,294.58,355.21,295.39,355.89,295.64Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#32384f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M345.64,361.58l-4.42,9.71s-9.54-11.85-13.12-24.65c-3.17-11.32,2.44-14.16,2.44-14.16,4.29-1.57,7.21,4.54,11.42,16.9C344.28,356.18,345.64,361.58,345.64,361.58Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M341.22,371.29s-.17-7.89,3.68-9.46,30.83-5.8,30.83-5.8l2.54,2.92S351.77,374.22,341.22,371.29Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M326,343.88a24.72,24.72,0,0,0,3.34,15.47,12.38,12.38,0,0,0,2.47,3.14,11.32,11.32,0,0,0,4.09,2.08,38.31,38.31,0,0,0,11.55,1.21c6.93,0,13.84-.45,20.75-.86a6.31,6.31,0,0,0,2.7-.56,6.39,6.39,0,0,0,2-2.1,2,2,0,0,0,.41-.87,1.87,1.87,0,0,0-.28-1l-2.25-4.65a1.53,1.53,0,0,0-2.3-.84,101.48,101.48,0,0,1-17.22,2.95,3.6,3.6,0,0,1-1.9-.2,3.18,3.18,0,0,1-1-1c-1.61-2.2-2.35-4.9-3.12-7.52-1.53-5.26-3.24-10.68-6.17-15.36-1.16-1.85-3.05-4-5.45-3-2.16.88-3.89,3.53-5,5.47A21,21,0,0,0,326,343.88Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M392.13,345.62h56.35a3.53,3.53,0,0,0,3.46-3.15l3.78-42.72a2.84,2.84,0,0,0-2.89-3.14H396.48a3.52,3.52,0,0,0-3.45,3.14l-3.79,42.72A2.85,2.85,0,0,0,392.13,345.62Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M394.31,345.62h56.35a3.52,3.52,0,0,0,3.45-3.15l3.79-42.72a2.84,2.84,0,0,0-2.89-3.14H398.66a3.53,3.53,0,0,0-3.46,3.14l-3.78,42.72A2.84,2.84,0,0,0,394.31,345.62Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84,327.65h16.36a0,0,0,0,1,0,0v26.83a8.18,8.18,0,0,1-8.18,8.18h0a8.18,8.18,0,0,1-8.18-8.18V327.65A0,0,0,0,1,420.84,327.65Z",
    transform: "translate(831.86 665) rotate(-180)",
    fill: "#68e1fd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M424.66,327.65H441a0,0,0,0,1,0,0v26.83a8.18,8.18,0,0,1-8.18,8.18h0a8.18,8.18,0,0,1-8.18-8.18V327.65A0,0,0,0,1,424.66,327.65Z",
    transform: "translate(839.48 665) rotate(-180)",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M385,392.15l-.33-.34c1.31,1.47,2.19,2.53,2.46,2.85C386.42,393.8,385.7,393,385,392.15Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#dc9bd5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M333.28,393.7c.79,4.61,3.92,8.55,7.74,11.24s8.3,4.25,12.77,5.61c2.64.81,4.28,4.19,6.67,5.6a6,6,0,0,1,2.19,1.83c.87,1.41.43,3.23,0,4.82q-3,10.54-6.08,21.08c-1,3.5-2,7.2-1.07,10.7s4.65,6.54,8.1,5.38l20.19-32.62s3.32-13.11-3.65-24.27c-3-4.81-26.56-24.65-26.56-24.65-6-.88-12.16-1.28-18-1.62C334.91,382.49,332.32,388.06,333.28,393.7Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#4c506d"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M353.55,378.42s24,19.57,26.56,24.65c7.06,14.17,3.65,24.27,3.65,24.27l17.67,28.4c4.09.09,9.57-1,9.78-5.1a8.1,8.1,0,0,0-.8-3.32q-6.66-16.57-13.3-33.14c-2.64-6.58-5.36-13.28-9.57-18.92l-.37-.49,0,0-.05-.07c-.27-.32-1.15-1.38-2.46-2.85l0,0c-3.82-4.28-11.29-11.92-18.19-15,0,0-8,2.21-12.83,1.62Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#2f3554"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M365.87,466.16c1.57,1.45,3.67,2.91,3.6,5a1,1,0,0,1-.17.6,1.16,1.16,0,0,1-.82.34c-4.85.54-9.36-2.42-13.13-5.52a5.31,5.31,0,0,1-2.16-2.89,5.92,5.92,0,0,1,1-3.53,34.43,34.43,0,0,0,2.18-5.64c-.17.58,2.27,2.63,2.68,3,.87.76,2.15,1.31,2.83,2.24a27.26,27.26,0,0,1,1.33,2.95A14.1,14.1,0,0,0,365.87,466.16Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M415.93,457.09c1.7.6,3.68.93,4.76,2.37a1.57,1.57,0,0,1,.36.91c0,.89-1,1.38-1.91,1.56-3.5.71-7.11.2-10.64-.3a3,3,0,0,1-1.31-.41,2.91,2.91,0,0,1-.92-1.58l-1.4-4.3a.69.69,0,0,1,0-.4.67.67,0,0,1,.28-.3,19,19,0,0,1,3-1.73c1.43-.64,1.53-.61,2.49.52A12.58,12.58,0,0,0,415.93,457.09Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M378.63,355.45c2.79-.44,5.92-.8,8.18.9a10.57,10.57,0,0,1,2.58,3.3,2.1,2.1,0,0,1-1.52,3.68c-2.57.62-5.34,1.21-7.8.24-1.82-.71-3.3-2.22-5.2-2.67a2.58,2.58,0,0,1-.92-.32,1.55,1.55,0,0,1-.52-.84C372.29,355.94,376.11,355.85,378.63,355.45Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#ec9c7d"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M408.53,464.88a1.14,1.14,0,0,0,.43.49,1.3,1.3,0,0,0,.87,0,23.83,23.83,0,0,1,4.78-.16,63.89,63.89,0,0,0,9.65-.89c1.4-.2,2.95-.5,3.77-1.65a1,1,0,0,0,.19-.46,1.07,1.07,0,0,0-.29-.66,11.81,11.81,0,0,0-5.33-3.64,6.84,6.84,0,0,0-2.43-.53,2.91,2.91,0,0,0-2.22,1c-.57.74-.65,1.79-1.31,2.45a3.51,3.51,0,0,1-2.66.71,22.55,22.55,0,0,1-3.29-.38c-.82-.16-2-.72-2.85-.51C406,461.13,408,463.93,408.53,464.88Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M352,466.24a1.26,1.26,0,0,0,.1.74,1.52,1.52,0,0,0,.82.56,26.53,26.53,0,0,1,4.63,2.89,75,75,0,0,0,9.73,5.3c1.45.7,3.11,1.41,4.62.83a1.14,1.14,0,0,0,.47-.31,1.18,1.18,0,0,0,.15-.81,13.43,13.43,0,0,0-2.74-6.85,7.69,7.69,0,0,0-2-2,3.29,3.29,0,0,0-2.73-.48c-1,.33-1.75,1.28-2.8,1.49a3.93,3.93,0,0,1-3-1,24,24,0,0,1-2.88-2.45c-.68-.67-1.46-2-2.38-2.29C352,461,352.07,465,352,466.24Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M52.26,373.8v94.47c0,1.81,1.2,3.29,2.68,3.29H96.09c1.48,0,2.68-1.48,2.68-3.29V373.8a.64.64,0,0,1,.56-.69H418.6a.64.64,0,0,1,.56.69v82.53a14.87,14.87,0,0,0,1.41.67l.71.23V373.8a3.85,3.85,0,0,0-.06-.69H463a.64.64,0,0,1,.56.69v94.47a.65.65,0,0,1-.56.7H421.84a.65.65,0,0,1-.56-.7v-2.42a4.76,4.76,0,0,1-2.12.11v2.31c0,1.81,1.2,3.29,2.68,3.29H463c1.48,0,2.68-1.48,2.68-3.29V373.8c0-1.81-1.2-3.28-2.68-3.28h-408C53.46,370.52,52.26,372,52.26,373.8Zm2.11,0a.64.64,0,0,1,.57-.69H96.71a3.85,3.85,0,0,0-.06.69v94.47a.65.65,0,0,1-.56.7H54.94a.65.65,0,0,1-.57-.7Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M52.26,373.8v94.47c0,1.81,1.2,3.29,2.68,3.29H96.09c1.48,0,2.68-1.48,2.68-3.29V373.8a.64.64,0,0,1,.56-.69H418.6a.64.64,0,0,1,.56.69v82.53a14.87,14.87,0,0,0,1.41.67l.71.23V373.8a3.85,3.85,0,0,0-.06-.69H463a.64.64,0,0,1,.56.69v94.47a.65.65,0,0,1-.56.7H421.84a.65.65,0,0,1-.56-.7v-2.42a4.76,4.76,0,0,1-2.12.11v2.31c0,1.81,1.2,3.29,2.68,3.29H463c1.48,0,2.68-1.48,2.68-3.29V373.8c0-1.81-1.2-3.28-2.68-3.28h-408C53.46,370.52,52.26,372,52.26,373.8Zm2.11,0a.64.64,0,0,1,.57-.69H96.71a3.85,3.85,0,0,0-.06.69v94.47a.65.65,0,0,1-.56.7H54.94a.65.65,0,0,1-.57-.7Z",
    transform: "translate(-26.2 -25.31)",
    fill: "url(#linear-gradient-4)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M54.94,471.56H96.09c1.48,0,2.68-1.48,2.68-3.29V373.8a.64.64,0,0,1,.56-.69H463a.64.64,0,0,1,.57.69v94.47a.64.64,0,0,1-.57.69,1.33,1.33,0,0,0,0,2.6c1.48,0,2.68-1.48,2.68-3.29V373.8c0-1.81-1.2-3.29-2.68-3.29H99.33c-1.48,0-2.68,1.48-2.68,3.29v94.47a.64.64,0,0,1-.56.69H54.94a.64.64,0,0,1-.57-.69V373.8a.64.64,0,0,1,.57-.69,1.33,1.33,0,0,0,0-2.6c-1.48,0-2.68,1.48-2.68,3.29v94.47C52.26,470.08,53.46,471.56,54.94,471.56Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M54.94,471.56H96.09c1.48,0,2.68-1.48,2.68-3.29V373.8a.64.64,0,0,1,.56-.69H463a.64.64,0,0,1,.57.69v94.47a.64.64,0,0,1-.57.69,1.33,1.33,0,0,0,0,2.6c1.48,0,2.68-1.48,2.68-3.29V373.8c0-1.81-1.2-3.29-2.68-3.29H99.33c-1.48,0-2.68,1.48-2.68,3.29v94.47a.64.64,0,0,1-.56.69H54.94a.64.64,0,0,1-.57-.69V373.8a.64.64,0,0,1,.57-.69,1.33,1.33,0,0,0,0-2.6c-1.48,0-2.68,1.48-2.68,3.29v94.47C52.26,470.08,53.46,471.56,54.94,471.56Z",
    transform: "translate(-26.2 -25.31)",
    fill: "url(#linear-gradient-5)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98.06,365.54H468.49a0,0,0,0,1,0,0v4.93a0,0,0,0,1,0,0H95.08a0,0,0,0,1,0,0v-1.95A3,3,0,0,1,98.06,365.54Z",
    transform: "translate(537.38 710.71) rotate(-180)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M49.44,364.32H92.1a3,3,0,0,1,3,3v3.17a0,0,0,0,1,0,0H49.44a0,0,0,0,1,0,0v-6.15a0,0,0,0,1,0,0Z",
    transform: "translate(118.32 709.49) rotate(-180)",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M89.13,362.89H470.76a.86.86,0,0,1,.75.93v2.74a.86.86,0,0,1-.75.93H89.13Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,362.89H96.8a.86.86,0,0,1,.75.93v2.74a.86.86,0,0,1-.75.93H47.3a1,1,0,0,1-.88-1.08V364A1,1,0,0,1,47.3,362.89Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,362.89H96.8a.86.86,0,0,1,.75.93v2.74a.86.86,0,0,1-.75.93H47.3a1,1,0,0,1-.88-1.08V364A1,1,0,0,1,47.3,362.89Z",
    transform: "translate(-26.2 -25.31)",
    fill: "url(#linear-gradient-6)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M361.87,304.46a1.51,1.51,0,0,1-.13.46,1,1,0,0,1-1.21.34,2.92,2.92,0,0,1-1.06-.86.83.83,0,0,1-.52.89,2,2,0,0,1-1.11.06,7.12,7.12,0,0,1-2.4-.86,1.89,1.89,0,0,1-3.34,1.08l-.51,1c-.47-.24-1,0-1.54-.06a2.25,2.25,0,0,1-1.83-2.27,7.77,7.77,0,0,1,.8-3.06,27.34,27.34,0,0,0,1.47-5.18,4,4,0,0,1,.53-1.63,2.73,2.73,0,0,1,1.45-.93c2.68-.79,5.77,1,7.46,3A11.18,11.18,0,0,1,361.87,304.46Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#32384f"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M630.55,463.79a14.31,14.31,0,0,1-1.15,6.13,10.22,10.22,0,0,1-4.46,4.14,17.54,17.54,0,0,1-13,1.28,2.54,2.54,0,0,1-1.51-.91,2.27,2.27,0,0,1-.27-1.29c.1-2.39,1.71-4.44,3.42-6.12s3.63-3.24,4.69-5.38c2-4,.51-14.77,8.11-13.05C632.71,450,630.72,459.3,630.55,463.79Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fdb9a9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M631.6,471.06s1.08,2.65-.25,4.2-15,10-24.15,3.21,12.46-7.71,12.46-7.71Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M631.07,464.88a2,2,0,0,0-2.46.64,8,8,0,0,1-7.31,2.62c-3-.72-4.19-4.17-5.68-4.19s-9.43,6.75-9.87,9.65,3.6,5,8.09,5.32,14.64-2.83,16.57-5.18S632.1,466.37,631.07,464.88Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M656.6,468a14.34,14.34,0,0,1-1.15,6.13,10.27,10.27,0,0,1-4.46,4.14,17.58,17.58,0,0,1-13,1.28,2.54,2.54,0,0,1-1.51-.91,2.2,2.2,0,0,1-.26-1.29c.09-2.39,1.7-4.44,3.41-6.12s3.64-3.24,4.69-5.39c2-4,.51-14.76,8.11-13C658.76,454.19,656.77,463.46,656.6,468Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fdb9a9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M657.65,475.21s1.08,2.66-.25,4.21-15,10-24.15,3.2,12.46-7.71,12.46-7.71Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M657.12,469a2,2,0,0,0-2.46.63,8,8,0,0,1-7.31,2.62c-3-.71-4.19-4.16-5.68-4.18s-9.43,6.74-9.87,9.65,3.6,5,8.09,5.32,14.64-2.83,16.57-5.19S658.15,470.52,657.12,469Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M662,355.79s1.42,78-4.36,104.07L643,461.67,632.85,354.82Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#473f47"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M616.71,347.27s-6.9,42.09,1.47,109.7l14.67,1.81L643,351.93Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#473f47"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M599.54,313.7c.16,2.82,1.07,5.28,3.52,6.1a5.23,5.23,0,0,0,.63.17c4.5.9,10.41-2.53,14.53-5.52a57.27,57.27,0,0,0,4.92-4V280.3l-21.91,22.43S599.23,308.76,599.54,313.7Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M618.06,314.35c0,1.41-.18,2.85-.18,4.26,0,7.79,1.8,15.82-.52,23.45-.52,1.71-1.25,3.53-.65,5.21a6.44,6.44,0,0,0,3.26,3.14c6.86,3.75,14.8,4.9,22.54,6,5.83.81,14.09,2.54,19.48-.6,2.29-1.33,3.07-3.82,3.8-6.3,2.33-7.9,3-16.39,3.63-24.57.09-1.08.16-2.16.22-3.24q.68-11.18.46-22.38c-.11-5.41-.53-11.26-4.07-15.35-4.71-5.44-13.8-9-20.7-10.31a23.27,23.27,0,0,0-6.81-.38,29,29,0,0,0-9.21,3.13c-3.43,1.69-6.48,3.13-8.17,6.52a45.91,45.91,0,0,0-3.82,12.34,44.33,44.33,0,0,0-.23,12.12c.21,2,.73,3.94.91,5.9C618,313.64,618.05,314,618.06,314.35Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M649.83,358.45c2.26.67,7.47-1.4,9.2-1.71,1-.18,2-.69,3-.95,5.16-1.28,5.77-15.77,6.28-19.67,1.33-10.31,3.39-21,3.51-31.31,0-4-.06-8.05-1.37-11.81s-4-7.24-7.73-8.59c-6.59-2.38-8.55,18.45-9.45,22.77l-4.95,23.56a53.76,53.76,0,0,0-1.35,8.81c-.18,4.13,1.14,7,2.2,10.73.6,2.05-1,6-.24,7.5A1.43,1.43,0,0,0,649.83,358.45Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#020202",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M634,267.19a5.07,5.07,0,0,0,3.18,1.59,17.38,17.38,0,0,0,3.06.05l.57,0a.66.66,0,0,1,.42.07.63.63,0,0,1,.18.46,33.92,33.92,0,0,1,.12,6.13h0c0,.37-.06.73-.1,1.1a2.16,2.16,0,0,0,.1,1.16,2,2,0,0,0,1.24.81,9,9,0,0,0,2.77.47,12.39,12.39,0,0,0,5.64-2,56.17,56.17,0,0,1,.55-10.45c.65-4.47,1.82-8.94,1.33-13.43a8.68,8.68,0,0,0-1.84-4.87c-1.61-1.81-4.22-2.4-6.65-2.39a16.86,16.86,0,0,0-9.13,2.5c-1,.69-1.13,1.56-1.36,2.7-.35,1.76-.63,3.55-.82,5.33-.22,2-.35,4.08-.38,6.13C632.83,264.18,632.93,266,634,267.19Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fdb9a9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M637.52,249.45c2.29.38,4.8,0,7,.87,3,1.23,4.3,5.15,3.3,8.26.87.31,1-1.26,1.71-1.9s2.19.22,2.3,1.31a6.76,6.76,0,0,1-1,3.11,9.24,9.24,0,0,0-.41,6.11c.14.47.49,1,1,.91s.81-.93,1.1-1.29a13.17,13.17,0,0,1,1.53-1.55c1.06-.93,2.23-1.75,3.32-2.66,1.93-1.61,3.72-3.81,3.61-6.33a5.62,5.62,0,0,0-1-2.85,6.43,6.43,0,0,0-1.88-1.83c-.31-.19-.66-.4-.73-.76a1.48,1.48,0,0,1,.08-.59c.66-2.55-.76-5.29-2.86-6.88a16.71,16.71,0,0,0-7.34-2.72c-1.68-.31-3.38-.54-5.08-.74a11.5,11.5,0,0,1-4.08-1,11.54,11.54,0,0,1,1.35-2.61,13.2,13.2,0,0,0-3.41,1.57,5.55,5.55,0,0,1,.45-1.7c-1.84.63-3.8,1.34-5,2.86a6,6,0,0,0-.18,6.8c1.31,2.07,3.38,2.9,5.65,3.45Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#f9692d"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M640.21,268.83l.57,0a.66.66,0,0,1,.42.07.63.63,0,0,1,.18.46,33.92,33.92,0,0,1,.12,6.13h0s5.86-1.49,5.66-8.7a34.89,34.89,0,0,1-6.91,2.05Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#de9f93"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M581.27,305.92a43.12,43.12,0,0,0,10.52,10.48,21,21,0,0,0,9.89,3.55,3.56,3.56,0,0,0,1.38-.15,3.77,3.77,0,0,0,1.9-1.32,11.06,11.06,0,0,0,2.54-6.25c.24-6-6.27-9.5-6.27-9.5s-14.82-4.72-16.58-4c-1,.42-1.88,2.5-2.52,4.31C581.61,304.6,581.27,305.92,581.27,305.92Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M581.27,305.92a43.12,43.12,0,0,0,10.52,10.48,21,21,0,0,0,9.89,3.55,3.56,3.56,0,0,0,1.38-.15,5.23,5.23,0,0,0,.63.17c4.5.9,10.41-2.53,14.53-5.52l0-.1-1.4-9a35.48,35.48,0,0,1-9.28,6.88,13.26,13.26,0,0,1-8,1.47,7.86,7.86,0,0,1-2.14-.64,70,70,0,0,1-15.27-10C581.61,304.6,581.27,305.92,581.27,305.92Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#020202",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M679.38,315.73c2,5.29,3.67,10.9,2.88,16.48-1,6.77-5.47,12.43-9.8,17.72-3.41.51-7.88.44-9.08-2.78a7.49,7.49,0,0,1-.23-3.2l.48-7c.22-3.12.42-6.32-.48-9.31-1-3.41-3.38-6.23-5.25-9.26a36,36,0,0,1-5.27-16.33c-.39-5.42,3.71-23,11.72-17.7,3.32,2.17,6.26,11.19,8,14.81Q676.28,307.27,679.38,315.73Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#68e1fd"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M661.33,354.69a1.46,1.46,0,0,0-.28.91c0,.32.39.62.68.47.81,2.51-.88,5.14-.88,7.78a2,2,0,0,0,.09.7,1.56,1.56,0,0,0,.59.71,3.14,3.14,0,0,0,3,.19,7.82,7.82,0,0,0,2.49-1.86,12.7,12.7,0,0,0,3.37-5.08,15.07,15.07,0,0,0,.5-2.76l.81-6.89C666.51,347.17,663.72,350.59,661.33,354.69Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fdb9a9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M582.18,293a2.81,2.81,0,0,0-.76-1.22.93.93,0,0,0-1.29.09,2.73,2.73,0,0,0-.25.81,1.66,1.66,0,0,1-1.58,1,5.41,5.41,0,0,1-1.93-.47,48.49,48.49,0,0,0-5.38-1.67,2.22,2.22,0,0,0-1.3,0,1.86,1.86,0,0,0-.92,1.13,7.07,7.07,0,0,0,1.12,6.62,11.32,11.32,0,0,0,5.76,3.79,28.71,28.71,0,0,0,6.91,1,3,3,0,0,0,1.74-.24C587.17,302.18,582.91,294.86,582.18,293Z",
    transform: "translate(-26.2 -25.31)",
    fill: "#fdb9a9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 444.31,
    y: 174.54,
    width: 9.74,
    height: 55.55,
    fill: "#68e1fd"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 457.96,
    y: 197.35,
    width: 9.74,
    height: 32.74,
    fill: "#68e1fd"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 471.6,
    y: 207.57,
    width: 9.74,
    height: 22.53,
    fill: "#68e1fd"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 485.24,
    y: 190.26,
    width: 9.74,
    height: 39.83,
    fill: "#68e1fd"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 498.88,
    y: 180.37,
    width: 9.74,
    height: 49.72,
    fill: "#68e1fd"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 512.52,
    y: 174.54,
    width: 9.74,
    height: 55.55,
    fill: "#68e1fd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessConferenceMonochromatic);
export default __webpack_public_path__ + "static/media/business_conference__monochromatic.7c7453d0de5a056085029e94ac2debe9.svg";
export { ForwardRef as ReactComponent };